import {
  Button,
} from 'antd';
import React, { useState, useEffect } from 'react';
import useTranslation from '../../../hooks/translation/useTranslation';
import { getRidePromotionsService } from '../../../../services/admin/ridePromotionServices';
import RidePromotionsTable from '../../tables/ridePromotionsTable/RidePromotionsTable';
import AddRidePromotionModal from '../../modals/addRidePromotionModal/AddRidePromotionModal';

function RidePromotions() {
  const { trans } = useTranslation();
  const [data, setData] = useState([]);
  const [show, setShow] = useState(false);

  const fetchData = async () => {
    const response = await getRidePromotionsService();
    setData(response?.data ?? []);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="flex flex-col gap-3">
      <Button
        onClick={() => setShow(true)}
      >
        {trans('add')}
      </Button>
      <RidePromotionsTable data={data} refetchData={fetchData} />
      <AddRidePromotionModal setShow={setShow} show={show} refetchData={fetchData} />
    </div>
  );
}

export default RidePromotions;
